import { CutoutState } from './cutout.types';

import { RootState } from '~/redux/store';

export const selectCustomCutouts = ({
  cutout,
}: RootState): CutoutState['customCutouts'] => cutout.customCutouts;

export const selectApplianceCutouts = ({
  cutout,
}: RootState): CutoutState['applianceCutouts'] => cutout.applianceCutouts;
